import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { X } from 'lucide-react';

export default function CookieConsent() {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem('equimarket_cookies');
    if (!accepted) {
      const timer = setTimeout(() => setShow(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => {
		localStorage.setItem('equimarket_cookies', 'accepted');
		setShow(false);
	};
  const reject = () => {
		localStorage.setItem('equimarket_cookies', 'rejected');
		setShow(false);
	};

  if (!show) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 cookie-banner" data-testid="cookie-consent">
      <div className="max-w-4xl mx-auto glass-panel rounded-sm p-6 flex flex-col sm:flex-row items-start sm:items-center gap-4 shadow-lg">
        <div className="flex-1">
          <h4 className="font-semibold text-[#1A3C34] mb-1 font-['Playfair_Display']">
						{t('gdpr.cookie_title')}
					</h4>
          <p className="text-sm text-[#666055]">{t('gdpr.cookie_text')}</p>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <Button onClick={reject} variant="outline"
									className="border-[#E6E2D6] text-[#666055] hover:bg-[#F2F0E9] rounded-sm h-9 px-4 text-sm"
									data-testid="cookie-reject">
            {t('gdpr.reject')}
          </Button>
          <Button onClick={accept}
									className="bg-[#1A3C34] hover:bg-[#153029] text-white rounded-sm h-9 px-6 text-sm"
									data-testid="cookie-accept">
            {t('gdpr.accept')}
          </Button>
        </div>
        <button onClick={() => setShow(false)}
								className="absolute top-2 right-2 sm:static text-[#666055] hover:text-[#1A3C34]">
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
